module.exports = __webpack_public_path__ + "static/media/banner2.1d3a8135.jpg";